import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { GlobalConstants } from 'src/app/common/global';
import { environment } from 'src/environments/environment';
import { membershipCount, MembershipFormResponse, MembershipProfileFromIdResponse } from './membership.model';
import { membershipTypes } from 'src/app/common/constants';

@Injectable({
  providedIn: 'root'
})
export class MembershipService {
  private membershipCount: membershipCount | null = null;
  private membershipFormFullFledged: any | null = null;
  private membershipFormCLubFriend: any | null = null;
  private membershipProfile: any | null = null;

  constructor(
    private httpClient: HttpClient
  ) { }

  submitcCmmissionerId(transId: number, commissionerId: string): Observable<any> {
    return this.httpClient.post<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/memberships/${transId}/commissioner/${commissionerId}`, {} ,GlobalConstants.headersCentral);    
  }

  getMembershipCountService(): Observable<any> {
    if (this.membershipCount) {
      return of(this.membershipCount);
    } else {
      return this.httpClient.get<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/memberships/count`).pipe(
        tap((data) => this.membershipCount = data)
      );
    }
  }

  getMembershipForm(profileType: string): Observable<MembershipFormResponse> {
    if (this.membershipFormFullFledged && profileType === membershipTypes.FULL_FLEDGED) {
      return of(this.membershipFormFullFledged);
    } else if(this.membershipFormCLubFriend && profileType === membershipTypes.CLUB_FRIEND) {
      return of(this.membershipFormCLubFriend);
    } else {
      return this.httpClient.get<MembershipFormResponse>(`${environment.apiUrl}/conn/${environment.connId}/v1/memberships/new?profileType=${profileType}`, { headers: GlobalConstants.headersCentral.headers }).pipe(
        tap((data) => 
          (profileType === membershipTypes.FULL_FLEDGED) ? this.membershipFormFullFledged = data : this.membershipFormCLubFriend = data
        )
      );
    }
  }

  getMembershipProfileFromId(membershipId: number): Observable<MembershipProfileFromIdResponse> {
    if (this.membershipProfile) {
      return of(this.membershipProfile);
    } else {
      return this.httpClient.get<MembershipProfileFromIdResponse>(`${environment.apiUrl}/conn/${environment.connId}/v1/profiles/${membershipId}`, { headers: GlobalConstants.headersCentral.headers }).pipe(
        tap((data) => this.membershipProfile = data)
      );
    }
  }
}
